/* biome-ignore-all lint/style/noParameterAssign: Need to pass ref for forwardRef */
/* biome-ignore-all lint/style/useComponentExportOnlyModules: Can't wrap certain elements */
/* biome-ignore-all lint/performance/noNamespaceImport: Cleaner when working with libraries */
import * as Popover from '@radix-ui/react-popover';
import React from 'react';
import { cn } from '@/app_lib/utils/utils';

const Root = Popover.Root;
Root.displayName = 'PopoverRoot';

const Portal = Popover.Portal;
Portal.displayName = 'PopoverPortal';

const Arrow = Popover.Arrow;
Arrow.displayName = 'PopoverArrow';

const Anchor = Popover.Anchor;
Anchor.displayName = 'PopoverAnchor';

const Trigger = React.forwardRef<
  React.ComponentRef<typeof Popover.Trigger>,
  React.ComponentPropsWithoutRef<typeof Popover.Trigger>
>(({ className, children, ...rest }, ref) => (
  <Popover.Trigger
    className={cn(className)}
    ref={ref}
    {...rest}
  >
    {children}
  </Popover.Trigger>
));
Trigger.displayName = 'PopoverTrigger';

const Content = React.forwardRef<
  React.ComponentRef<typeof Popover.Content>,
  React.ComponentPropsWithoutRef<typeof Popover.Content>
>(({ className, children, ...rest }, ref) => (
  <Popover.Content
    className={cn('', className)}
    ref={ref}
    {...rest}
  >
    {children}
  </Popover.Content>
));
Content.displayName = 'PopoverContent';

const Close = React.forwardRef<
  React.ComponentRef<typeof Popover.Close>,
  React.ComponentPropsWithoutRef<typeof Popover.Close>
>(({ className, children, ...rest }, ref) => (
  <Popover.Close
    className={cn('', className)}
    ref={ref}
    {...rest}
  >
    {children}
  </Popover.Close>
));
Close.displayName = 'PopoverClose';

export { Root, Trigger, Close, Content, Portal, Arrow, Anchor };
